import {Injectable} from '@angular/core';
import {fromEvent, Observable, of} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable()
export class WindowMessageService {
    constructor() {

    }

    /**
     * Watch for messages and return a stream
     */
    public get(): Observable<MessageEvent> {
        return fromEvent(window, 'message').pipe(filter((messageEvent: MessageEvent) => JSON.stringify(messageEvent.data).includes('$')));
    }

    /**
     * Send a message to the window context
     * @param message
     */
    public post(message: any): Observable<void> {
        return of(window.postMessage(message, '*'));
    }
}
